var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "customizer-3D",
    style: {
      backgroundImage: 'url(' + _vm.paletteSkinImage + ')'
    }
  }, [_c('div', {
    class: ['customizer-3D-scene', this.themeVideo, {
      'is-apac': this.regionIsApac
    }],
    attrs: {
      "id": "scene"
    },
    on: {
      "click": function click($event) {
        return _vm.rayTraceComponent($event);
      }
    }
  }), _c('custom-tool-tip', {
    attrs: {
      "showToolTip": _vm.showRotateMsg,
      "cssName": "coachmark",
      "message": "dragShoeRotateMsg",
      "asset": "".concat(_vm.customsAssets, "/svg/customizer/icon-rotate.svg")
    }
  }), _c('custom-tool-tip', {
    attrs: {
      "showToolTip": _vm.showComponentMsg,
      "cssName": "component-restrict",
      "message": "exclusiveComponentMsg",
      "asset": ""
    }
  }), _c('div', {
    staticClass: "customizer-3D-rotate",
    style: {
      'background-image': "url(".concat(_vm.customsAssets, "/svg/customizer/icon-rotate-to-customize.svg)")
    }
  }, [_vm._v(_vm._s(_vm.translations.rotateCustomizeMsg))])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }